function _updateCart2() {
  $.ajax({
    type: "GET",
    url: "/cart.json",
    dataType: "jsonp",
    success: function (data) {
      window.wetheme.drawer.updateCartDrawer(data);
      const itemCount = data.item_count > 0 ? data.item_count : "";
     $("[data-header-cart-count]").text(itemCount);
      $(".slide-menu-cart").trigger("click");
    },
  });
}

/* Mandatory JQUERY JS */
$(document).ready(function () {
  $(".color-swatch").on("click", function () {
    var variantPrice = $(this).data("price");
    var variantId = $(this).data("variantid");
    // You can also update other parts of your UI with these values
    // For example:
    $(".price_number_price").text(variantPrice);
    $(".variantGetId ").val(variantId);
  });
  $("#size-select").on("change", function () {
    var selectedOption = $(this).find("option:selected");
    var price = selectedOption.data("price");
    var variantId = selectedOption.data("variantid");

    // Now you can use price and variantId as needed
    console.log("Select Price: " + price);
    console.log("Select Variant ID: " + variantId);

    // You can also save them in variables or perform any other actions
  });

  // Set initial main-left-thumbnail-img src to the first product-own-img src
  var firstProductImgSrc = $(".product-own-img").first().attr("src");
  //$('.main-left-thumbnail-img').attr('src', firstProductImgSrc);

  // Change main-left-thumbnail-img src on hover over product-own-img
  $(".product-own-img").hover(
    function () {
      var newSrc = $(this).attr("src");
      $(".main-left-thumbnail-img").attr("src", newSrc);
    },
    function () {
      var newSRC = $("#shop_image").val();
      $(".main-left-thumbnail-img").attr("src", newSRC);
      // Optionally, you can set it back to the initial image or leave it as is
    }
  );
  $(".product-select-box").change(function(){
    console.log("Change");
  });
});
$(document).ready(function () {
  var stickyImage = $("#stickyImage");
  var footer = $(".section-index-newsletter");
  var stickyOffset = $("#stickyImage").offset().top;
  var topOffset = 180; // Adjust this value for your top offset
  var topOffsetAlt = -350; // Adjust this value for your top offset

  $(window).scroll(function () {
    var windowScrollTop = $(window).scrollTop();
    var footerOffsetTop = footer.offset().top;
    var imageHeight = stickyImage.outerHeight();

    if (
      windowScrollTop >= stickyOffset - topOffsetAlt &&
      windowScrollTop < footerOffsetTop - imageHeight - topOffset
    ) {
      stickyImage.addClass("sticky");
      stickyImage.css({
        position: "fixed",
        top: "180px",
      });
    } else if (windowScrollTop >= footerOffsetTop - imageHeight - topOffset) {
      stickyImage.css({
        position: "absolute",
        top: footerOffsetTop - imageHeight - topOffset + "px",
      });
    } else {
      stickyImage.removeClass("sticky");
      stickyImage.css({
        position: "relative",
        top: "0",
      });
    }
  });

  $(document).on("click", ".form-swatch-item", function () {
    var optionsLength = $(this).parents().eq(5).find(".optionselector").length;
    if (optionsLength <= 2) {
      var variantId = $(this).find("input").attr("data-id");
      var customAddToCartWrapper = $(".custom-add-to-cart-wrapper");
      var inputElement = customAddToCartWrapper.find("input");
      inputElement.val(variantId);
    } else {
      var concatString = "";
      $(this)
        .parents()
        .eq(5)
        .find(".optionselector input:checked")
        .each(function () {
          var val1 = $(this).val().toLowerCase();
          concatString = concatString + val1 + " / ";
        });
      concatString = $.trim(concatString);
      var target = $.trim(concatString.substring(0, concatString.length - 1));
      $(this)
        .parents()
        .eq(5)
        .find("#product-select-simple option")
        .each(function () {
          var checked = $(this).attr("selected");
          if (checked) {
            $(this).prop("selected", false);
          }
        });
      $(this)
        .parents()
        .eq(5)
        .find("#product-select-simple option")
        .each(function () {
          var optTxt = $.trim($(this).text().toLowerCase());
          if (optTxt.indexOf(target) > -1) {
            $(this).prop("selected", true);
          }
        });
      var selectedOption = $(this)
        .parents()
        .eq(5)
        .find("#product-select-simple")
        .val();
      $(this).parents().eq(5).find(".variantGetId").val(selectedOption);
    }
  });
    $(".template-page .productSelect").change(function(){
    var selectedOption = $(this).find("option:selected").data("optionid");
    $("#"+selectedOption).parent().find("label").trigger("click");
    //  window.alert($(this).parents().eq(5).find(".optionselector").length);
    if($(this).parents().eq(5).find(".optionselector").length <= 2){
      var option_selectedVal = $.trim($(this).find("option:selected").val().toLowerCase());
      if(option_selectedVal){
        var obj = $(this).parent().parent().find(".product-select option");
        resetSelect(obj);
        $(this).parent().parent().find(".product-select option").each(function(){
          var option_txt = $.trim($(this).text().toLowerCase());
          if(option_selectedVal == option_txt){
            $(this).prop("selected",true);
          }
        });
        //$("#product-select-simple")
      }
      var selectedOptPrice = $(this).parent().parent().find(".product-select-box option:selected").data("price");
      $(this).parent().parent().parent().find("#product-price .money").html(selectedOptPrice);
    }else{
      var concatString = "";
      $(this)
        .parents()
        .eq(5)
        .find(".optionselector input:checked")
        .each(function () {
          var val1 = $(this).val().toLowerCase();
          concatString = concatString + val1 + " / ";
        });
      concatString = $.trim(concatString);
      var target = $.trim(concatString.substring(0, concatString.length - 1));
      $(this)
        .parents()
        .eq(5)
        .find("#product-select-simple option")
        .each(function () {
          var checked = $(this).attr("selected");
          if (checked) {
            $(this).prop("selected", false);
          }
        });
      var obj =$(this).parents().eq(5).find("#product-select-simple option");
       resetSelect(obj);
       
      $(this)
        .parents()
        .eq(5)
        .find("#product-select-simple option")
        .each(function () {
          var optTxt = $.trim($(this).text().toLowerCase());
          if (optTxt.indexOf(target) > -1) {
            $(this).prop("selected", true);
           }
        });
      var selectedOption = $(this)
        .parents()
        .eq(5)
        .find("#product-select-simple option:selected")
        .val();
      $(this).parents().eq(5).find(".variantGetId").val(selectedOption);
       var selectedOptPrice = $(this).parents().eq(5).find(".product-select-box option:selected").data("price");
      $(this).parents().eq(5).find("#product-price .money").html(selectedOptPrice);
    }
  });
   $(".template-page .productRadio").change(function(){
    var selectedOption = $(this).val();
    $("#"+selectedOption).parent().find("label").trigger("click");
    if($(this).parents().eq(5).find(".optionselector").length == 1){
      var option_selectedVal = $.trim($(this).val().toLowerCase());
      if(option_selectedVal){
        var obj = $(this).parent().parent().find(".productRadio");
        resetSelect(obj);
        $(this).parent().parent().find(".productRadio").each(function(){
          var option_txt = $.trim($(this).text().toLowerCase());
          if(option_selectedVal == option_txt){
            $(this).prop("checked",true);
          }
        });
      }
    }else{
      var concatString = "";
      $(this)
        .parents()
        .eq(5)
        .find(".optionselector input:checked")
        .each(function () {
          var val1 = $(this).val().toLowerCase();
          concatString = concatString + val1 + " / ";
        });
      concatString = $.trim(concatString);
      var target = $.trim(concatString.substring(0, concatString.length - 1));
      $(this)
        .parents()
        .eq(5)
        .find("#product-select-simple option")
        .each(function () {
          var checked = $(this).attr("selected");
          if (checked) {
            $(this).prop("selected", false);
          }
        });
      $(this)
        .parents()
        .eq(5)
        .find("#product-select-simple option")
        .each(function () {
          var optTxt = $.trim($(this).text().toLowerCase());
          if (optTxt.indexOf(target) > -1) {
            $(this).prop("selected", true);
          }
        });
      var selectedOption = $(this)
        .parents()
        .eq(5)
        .find("#product-select-simple")
        .val();
      $(this).parents().eq(5).find(".variantGetId").val(selectedOption);
    }
   
  });
});

$(document).ready(function () {
    var stickyImage1 = $("#stickyImage");
    var $footer1 = $(".section-index-newsletter");
    var stickyOffset1 = stickyImage1.offset().top;
    var topOffset1 = 300; // Adjust this value for your top offset
    var topOffsetAlt1 = 250; // Adjust this value for your top offset

    console.log("Initial offset top of the sticky image:", stickyOffset1);
    console.log("Footer offset top:", $footer1.offset().top);
    console.log("Threshold to make the image fixed (scroll position):", stickyOffset1 + 850);

    $(window).scroll(function () {
        var windowScrollTop = $(window).scrollTop();
        var footerOffsetTop = $footer1.offset().top;
        var imageHeight = stickyImage1.outerHeight();
        // When window scroll position is within the sticky range
        if (
            windowScrollTop >= stickyOffset1 - topOffsetAlt1 &&
            windowScrollTop < footerOffsetTop - imageHeight - topOffset1
        ) {
            stickyImage1.addClass("sticky1");
            stickyImage1.css({
                position: "fixed",
                top: "180px",
                height:"fit-content"
            });
        } 
        // When window scroll position is within the footer range
       else if (windowScrollTop >= footerOffsetTop - imageHeight - topOffset1) {
            stickyImage1.removeClass("sticky1");
            stickyImage1.css({
                position: "absolute",
                top: footerOffsetTop - imageHeight - topOffset1 + "px"
            });
        }
        // Reset the position when not in the sticky or footer range
        else {
            stickyImage1.removeClass("sticky1");
            stickyImage1.css({
                position: "relative",
                top: "0"
            });
        }
    });
});


